// Includes only the "core" of graphlib
module.exports = {
  Graph: require("./graph"),
  version: require("./version")
};



//////////////////
// WEBPACK FOOTER
// ./~/graphlib/lib/index.js
// module id = 123
// module chunks = 0